import { ErrorResponse } from "@/app/types/error";
import { getApi } from "@/app/api/config";
import { getItemSessionStorage } from "@/lib/utils";
import { ELocalStorageKeys } from "@/app/types/localStorage";
import { PatientDTO } from "./types";
import { PatientMedicationsResponse } from "./types";
import { IDailyEntry } from "@/app/types/registers";

export interface PatientRegistersResponse {
  status: string;
  data: { patient: PatientDTO; registers: IDailyEntry[] };
}

export const getConnectedPatient = async (
  patientId: string,
): Promise<PatientRegistersResponse | ErrorResponse> => {
  const token = await getItemSessionStorage(ELocalStorageKeys.TOKEN);

  const response = await getApi<PatientRegistersResponse | ErrorResponse>(
    `/provider/patient/${patientId}`,
    {},
    token,
  );

  if (response.status === "fail") return response as ErrorResponse;
  return response;
};

export const getPatientRegisters = async (
  patientId: string,
  week?: number,
): Promise<PatientRegistersResponse | ErrorResponse> => {
  const token = await getItemSessionStorage(ELocalStorageKeys.TOKEN);

  let endpointURL = `/provider/patient/${patientId}`;
  if (week) {
    endpointURL += `?week=${week}`;
  }

  const response = await getApi<PatientRegistersResponse | ErrorResponse>(
    endpointURL,
    {},
    token,
  );
  if (response.status === "fail") return response as ErrorResponse;
  return response;
};

export const getPatientsMedications = async (
  patientId: string,
): Promise<PatientMedicationsResponse | ErrorResponse> => {
  const token = await getItemSessionStorage(ELocalStorageKeys.TOKEN);

  const response = await getApi<PatientMedicationsResponse | ErrorResponse>(
    `/provider/graph/patient/${patientId}/medication`,
    {},
    token,
  );
  if (response.status === "fail") return response as ErrorResponse;
  return response;
};
